import { join } from "@/app/utils"
import { Button } from "@/components/buttons/button"
import { SidebarMenuItem } from "@/components/sidebar_menu/sidebar_menu.item"
import { getNavigationMenuOptions } from "@/components/sidebar_menu/sidebar_menu.options_definition"
import { List, X } from "@phosphor-icons/react"
import Image from "next/image"
import Link from "next/link"
import { useState } from "react"

export function SidebarMenuMobile() {
  const navigationOptions = getNavigationMenuOptions()

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  function toggleMenu() {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      {/* Mobile Menu Icon*/}
      <Button
        type="button"
        color="tertiary"
        className="xl:hidden"
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}>
        <span className="sr-only">Toggle menu</span>
        <List />
      </Button>

      {/* Mobile Sidebar */}
      <div
        className={join(
          isMenuOpen ? "translate-x-0" : "-translate-x-full",
          "fixed inset-0 z-[999] w-full transform bg-main-light transition duration-300 ease-in-out xl:hidden"
        )}>
        <div className="flex h-16 items-center justify-between border-b border-main-200 px-6">
          <Link
            href="https://grafiniti.com"
            target="_blank"
            className="flex items-center">
            <Image
              className="w-24"
              src="/images/grafiniti-logo.png"
              width={200}
              height={200}
              alt="Grafiniti Logo"
            />
          </Link>
          <button
            type="button"
            className="text-main-700 hover:text-primary-500"
            onClick={toggleMenu}>
            <span className="sr-only">Close menu</span>
            <X className="h-6 w-6" />
          </button>
        </div>
        <nav className="mt-6 px-6">
          <ul role="list" className="space-y-2">
            {navigationOptions.map((item) => (
              <SidebarMenuItem
                key={item.name}
                onAction={toggleMenu}
                item={item}
                isMobile
              />
            ))}
          </ul>
        </nav>
      </div>
    </>
  )
}
